import { useSelector } from "react-redux";
import Loading from "./components/common/Loading";
import RouteIdentifier from "./routing/RouteIdentifier";
import routes from "./routing/router";
import { useEffect, useState } from "react";
import http from "./services/api/http";


function App() {
  const { loadingFromStore } = useSelector((state) => state.loading);
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    http.interceptors.request.use(
      (config) => {
        setLoading(true);
        return config;
      },
      (error) => {
        setLoading(false);
        return Promise.reject(error);
      }
    );

    http.interceptors.response.use(
      (config) => {
        setLoading(false);
        return config;
      },
      (error) => {
        setLoading(false);
        return Promise.reject(error);
      }
    );
  }, []);
  
  return (
    <>
      {(loading || loadingFromStore) && <Loading />}
      <RouteIdentifier routes={routes} />
    </>
  );
}

export default App;
